<style lang="scss">
.defaultLayout {
  &__navbar {
    position: fixed;
    width: 100%;

    .navbar-start {
      @include media("<=tablet") {

        >a.navbar-item,
        .navbar-link {
          font-weight: bold;
        }
      }

      .navbar-link:not(.is-arrowless)::after {
        border-color: $primary;
      }
    }

    @media screen and (max-width: 1087px) {
      .navbar-dropdown {
        display: none;
      }

      .navbar-item.is-active .navbar-dropdown {
        display: block;
      }
    }
  }

  &__footer {
    background-color: $theme-blue;
    color: white;

    a {
      color: white;

      &:hover,
      &:visited,
      &:active {
        color: white;
      }

      &:hover>.icon {
        color: $theme-yellow;
      }

      >.icon {
        display: inline-block;
        margin: .5em;
        transition: color .5s;
        padding: .5em;
      }
    }
  }

  &__burger {
    color: white;

    &:hover {
      color: white;
    }
  }

  &__content {
    padding-top: 3rem;
  }
}
</style>

<template>
  <div id="inner">
    <nav-bar :withBG="true"></nav-bar>
    <div id="content">
      <nuxt />
    </div>
    <div id="bottom">
      Website created by Open Source Hong Kong.
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout',
  components: {
    // PageFooter: () => import('~/components/PageFooter.vue'),
    NavBar: () => import('~/components/NavBar.vue'),
  },
  mounted() {
  },
  props: {
    /**
     * @type string
     */
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      showNavbar: false,
      showArchive: false,
      showAbout: false,
    };
  },
  methods: {
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    handleClick() {
      this.showArchive = false;
      this.showArchive = false;
    },
  },
};
</script>
